import React from 'react';
import moment from 'moment';
import P from '../../Common/BackBox/P.jsx';

const Comentario = (props) => {

    return (        
            <div class="detalle-comment">
                <P clase="name" valor={"Orden: " + props.Orden} />
                <P clase="name" valor={"Fecha: " + moment(props.Fecha).format("DD/MM/YYYY")} />

                {props.Calificacion !== undefined && <div>
                    <ul class="stars1">
                        {props.generarEstrellas(props.Calificacion)}
                    </ul>
                </div>}

                <P clase="text" valor={props.Comentario} />
            </div>        
    );

}
export default Comentario;